import React from 'react';

const CloseIcon = () => (
  <svg
    role="presentation"
    focusable="false"
    width="34"
    height="35"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 34 35"
  >
    <rect
      fillRule="nonzero"
      transform="rotate(45 16.998 17.002)"
      x="-4.215"
      y="13.844"
      width="42.426"
      height="6.316"
      rx=".75"
    />
    <path
      d="M29.235.3l-13.94 13.939a.75.75 0 0 0 0 1.06l3.406 3.406a.75.75 0 0 0 1.06 0l13.94-13.94a.75.75 0 0 0 0-1.06L30.295.299a.75.75 0 0 0-1.06 0z"
      fillRule="nonzero"
    />
    <path d="M3.738 34.766l10.73-10.73a.59.59 0 0 0 0-.855l-3.606-3.606a.59.59 0 0 0-.856 0l3.396-3.395-7.582 7.582-3.425 3.424a1.432 1.432 0 0 0-.428 1.04l-.001 5.012c0 .367.183.795.427 1.04l.49.488" />
  </svg>
);

export default CloseIcon;
